import React from 'react';
import {Table, Card, Button, Select, Typography, DatePicker, Tag, Modal, Space, Divider, Input} from "antd";
import {emInterimReport, emInterimReportList, visualize} from '../api/api'
import moment from "moment";

export const EMSelect = ({value,onChange})=>{

    const [em, setEm] = React.useState([])

    const load = async ()=>{
        const {data:{rows = []}} = await visualize('em_name')
        setEm(rows.map(({id, full_name})=>({id,full_name})))
    }

    React.useEffect(()=>{
        load();
    },[])

    return <React.Fragment>
        <Select showSearch optionFilterProp={'children'} placeholder="Select an EM" style={{width: 400}} key={em} onChange={onChange} value={value}>
            {
                em.map(({id,full_name})=><Select.Option key={id} value={id}>{full_name}</Select.Option>)
            }
        </Select>
    </React.Fragment>
}


export const EMInterimReportView = (props)=>{

    const [em,setEm] = React.useState()
    const [source, setSource] = React.useState([]);
    
    const load = async ()=>{
        if(em) {
            const {data:{rows=[]}} = await emInterimReportList({id:em})
            setSource(rows)
        }else
            setSource([])
    }

    React.useEffect(()=>{
        load();
    },[em])

    return <React.Fragment>
        <Card
            title={<EMSelect value={em} onChange={e=>setEm(e)}/>}
        >
            <Table
                dataSource={source}
                pagination={false}
                size={`small`}
            >

                <Table.Column dataIndex={'id'} title={'Interim Report'} render={(value, row, index) => {

                    const { id, em_id, duration } = row;
                    return <Space key={index}>
                        <Button disabled={false} onClick={async () => {
                            await emInterimReport(em_id, id, duration)
                        }}>Download</Button>
                    </Space>;
                }} />
                 <Table.Column dataIndex={'start_date'} title={'From'} render={(value,row,index)=>{
                    return <Typography.Text>{value}</Typography.Text>
                }}/>
                <Table.Column dataIndex={'end_date'} title={'To'} render={(value,row,index)=>{
                    return <Typography.Text>{value}</Typography.Text>
                }}/>
             </Table>
        </Card>

    </React.Fragment>
}